module.exports = __webpack_public_path__ + "static/media/sweet_8_tablet.628a65bc.png";